<div class="footer-bg">
  <img src="assets/img/bg/footer-bg.png" alt=""
    style="width: 100%; height: 100%;">
</div>
<footer class="footer-three footer-six">
  <div class="footer-top">
    <div class="container">
      <div class="row">
        <div class="col-lg-8">
          <div class="footer-widget">
            <div class="footer-about">
              <div class="mb-4">
                <h3 class="text-white">Book Your Travel</h3>
                <p>Our mission is to offer you a seamless and enjoyable car rental experience. Whether you’re planning a
                  road trip</p>
              </div>
            </div>
            <ul class="social-icon">
              <li>
                <a target="_blank" href="https://www.tiktok.com/@bookatravel123?_r=1&_t=ZG-93yablUtejJ"><i class="fa-brands fa-tiktok"></i></a>
              </li>
              <li>
                <a target="_blank" href="https://x.com/bookatravel123"><i class="fa-brands fa-x-twitter"></i></a>
              </li>
              <li>
                <a target="_blank" href="https://www.instagram.com/bookatravel123?igsh=MW5tdjN1c3I3bm51bg=="><i class="fa-brands fa-instagram"></i></a>
              </li>
              <li>
                <a target="_blank" href="https://www.linkedin.com/in/management-bookatravel-386568399?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"><i class="fa-brands fa-linkedin"></i></a>
              </li>

            </ul>
          </div>
        </div>
        <!-- <div class="col-lg-4">
          <div>
            <h5 class="mb-2 text-white">Subscribe to Keep Updated</h5>
            <div class="footer-input">
              <div class="input-group align-items-center justify-content-center">
                <span class="input-group-text px-1"><i class="isax isax-message-favorite5"></i></span>
                <input type="email" class="form-control" placeholder="Enter Email Address">
                <button type="submit" class="btn btn-primary btn-md">Subscribe</button>
              </div>
            </div>
          </div>
        </div> -->
      </div>
      <div class="row">
        <div class="col-lg-3 col-md-6">
          <div class="footer-widget">
            <h5>Pages</h5>
            <ul class="footer-menu">
              <li>
                <a [routerLink]="['/info', 'TEAM']">Our Team</a>
              </li>
              <li>
                <a [routerLink]="['/info', 'PRICING']">Pricing Plans</a>
              </li>
              <li>
                <a [routerLink]="['/info', 'GALLERY']">Gallery</a>
              </li>
              <li>
                <a [routerLink]="['/info', 'SETTINGS']">Settings</a>
              </li>
              <li>
                <a [routerLink]="['/info', 'PROFILE']">Profile</a>
              </li>
              <li>
                <a [routerLink]="['/info', 'LISTINGS']">Listings</a>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-lg-3 col-md-6">
          <div class="footer-widget">
            <h5>Company</h5>
            <ul class="footer-menu">
              <li>
                <a [routerLink]="['/info', 'ABOUT']">About Us</a>
              </li>
              <li>
                <a [routerLink]="['/info', 'CAREERS']">Careers</a>
              </li>
              <li>
                <a [routerLink]="['/info', 'BLOG']">Blog</a>
              </li>
              <li>
                <a [routerLink]="['/info', 'PARTNERS']">Our Partners</a>
              </li>
            </ul>
          </div>
        </div>
        <!-- <div class="col-lg-3 col-md-6">
          <div class="footer-widget">
            <h5>Destinations</h5>
            <ul class="footer-menu">
              <li>
                <a [routerLink]="['/info', 'HAWAII']">Hawaii</a>
              </li>
              <li>
                <a [routerLink]="['/info', 'ISTANBUL']">Istanbul</a>
              </li>
              <li>
                <a [routerLink]="['/info', 'SANDIEGO']">San Diego</a>
              </li>
              <li>
                <a [routerLink]="['/info', 'BELGIUM']">Belgium</a>
              </li>
              <li>
                <a [routerLink]="['/info', 'NEWYORK']">New York</a>
              </li>
              <li>
                <a [routerLink]="['/info', 'LOSANGELES']">Los Angeles</a>
              </li>
            </ul>
          </div>
        </div> -->
        <div class="col-lg-3 col-md-6">
          <div class="footer-widget">
            <h5>Quick Links</h5>
            <ul class="footer-menu">
              <li>
                <a [routerLink]="['/info', 'LEGAL']">Legal Notice</a>
              </li>
              <li>
                <a [routerLink]="['/info', 'PRIVACY']">Privacy Policy</a>
              </li>
              <li>
                <a [routerLink]="['/info', 'TERMS']">Terms and Conditions</a>
              </li>
              <li>
                <a [routerLink]="['/info', 'REFUND']">Refund Policy</a>
              </li>
              <li>
                <a [routerLink]="['/info', 'SUPPORT']">Chat Support</a>
              </li>
              <li>
                <a [routerLink]="['/info', 'TICKETS']">Tickets</a>
              </li>
              <li>
                <a [routerLink]="['/info', 'FAQ']">FAQ</a>
              </li>
              <li>
                <a [routerLink]="['/garantieregeling']">Garantieregeling</a>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-lg-3 col-md-6">
          <div class="footer-widget">
             <div class="footer-logos d-flex justify-content-center align-items-center mt-4">
    <img src="assets/img/logo.png" alt="App Logo" class="footer-logo me-3">
    <img src="assets/img/logo-sto-garant-white.svg" alt="Garant Logo" class="footer-logo">
  </div>
  </div></div>
      </div>
    </div>
  </div>
  <!-- Footer Bottom -->
  <div class="footer-bottom">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-5 mx-auto">
          <p class="text-center">Copyright &copy; 2025. All Rights Reserved, <a href="javascript:void(0);"
              class="text-primary fw-medium">BookYourTravel</a></p>
        </div>
      </div>
    </div>
  </div>
  <!-- /Footer Bottom -->

</footer>
